import {
  BIA_MY_ACCOUNT,
  BUTTON_SUBMISSION,
  INTERACTION,
  OVERLAY,
  MY_ACCOUNT_SETTINGS,
  LIST_CREATE_GROUP,
  LIST_EDIT_GROUP,
  LIST_SETTINGS,
  LIST_EMAIL,
  LIST_PRINT,
  LIST_VIEW_MODIFICATION,
  LIST_ADD,
  LIST_REMOVE,
  LIST_PAGINATION_SETTINGS_PREFIX,
  LIST_REARRANGE_PRODUCT,
  LIST_NOTE_SAVED,
  LIST_FUNCTION_SELECT_ALL,
  LIST_FUNCTION_DESELECT_ALL,
  LIST_FUNCTION_COMPARE,
  LIST_FUNCTION_EXPAND_ALL,
  LIST_FUNCTION_COLLAPSE_ALL,
  LIST_MAKE_NOTE
} from '../constants';
import { getState } from '../analytics-state';

export const productList = () => {

  const setMyAccountSettingsAnalytics = ( setting = "" ) => {
    
    if (!setting) return;

    const ddoEvent = {
      category: { primaryCategory: BUTTON_SUBMISSION },
      eventInfo: { eventName: MY_ACCOUNT_SETTINGS },
      myAccount: {
        settings: setting
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  };

  LIFE_CYCLE_EVENT_BUS.on('product-list.remove-product', ({ output }) => {
    const { products } = output;
    const item = products.map((product) => ({
      quantity: product.quantity,
      price: {
        basePrice: product.price,
      },
      productInfo: {
        sku: product.itemId,
        intent: {
          status: product.intentStatus || 'no',
          resolvedIntent: product.resolvedFromIntent || 'no'
        }
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: LIST_VIEW_MODIFICATION
      },
      eventInfo: {
        eventName: LIST_REMOVE
      },
      item
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.increment-quantity', ({ output }) => {
    const { products } = output;
    const item = products.map((product) => ({
      quantity: product.quantity,
      price: {
        basePrice: product.price
      },
      productInfo: {
        sku: product.itemId,
        intent: {
          status: product.intentStatus || 'no',
          resolvedIntent: product.resolvedFromIntent || 'no'
        }
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: LIST_VIEW_MODIFICATION
      },
      eventInfo: {
        eventName: LIST_ADD
      },
      item
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.atc', ({ output }) => {
    const { pageType = null } = getState() || {};
    const { products } = output;
    const items = products.map((product) => ({
      productID: product.itemId,
      index: product?.index,
      intentStatus: product.intentStatus || 'no',
      resolvedFromIntent: product.resolvedFromIntent || 'no'
    }));
    const ddoEvent = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'cart add location'
      },
      eventMode: 'stash',
      stash: {
        pageType,
        sharedSection: 'n/a',
        section: 'n/a',
        component: 'n/a',
        target: 'atc',
        items
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.email-list', () => {
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: LIST_EMAIL
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.print-list', () => {
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: LIST_PRINT
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.pagination', ({ output }) => {
    const { page } = output;
    const settings = `${LIST_PAGINATION_SETTINGS_PREFIX}${page}`;
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: { settings }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.post-load-error', ({ output }) => {
    const {
      type = 'error',
      displayType = 'page',
      pageSection = '',
      message = '',
      code = ''
    } = output || {};
    const ddoEvent = {
      category: {
        primaryCategory: 'error'
      },
      eventInfo: {
        eventName: 'post page error',
        error: [{
          type,
          displayType,
          pageSection,
          message,
          code
        }]
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.rearranging-product', () => {
    setMyAccountSettingsAnalytics(LIST_REARRANGE_PRODUCT);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.expand-all', () => {
   setMyAccountSettingsAnalytics(LIST_FUNCTION_EXPAND_ALL);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.collapse-all', () => {
    setMyAccountSettingsAnalytics(LIST_FUNCTION_COLLAPSE_ALL);
  });

  // List Create Group Analytics Events
  LIFE_CYCLE_EVENT_BUS.on('product-list.create-group', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_CREATE_GROUP
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.create-group-success', () => {
    setMyAccountSettingsAnalytics( 'list details: group: group created' );     
  });

  // Requirement 3: Edit Group Settings
  LIFE_CYCLE_EVENT_BUS.on('product-list.edit-group', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_EDIT_GROUP
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.edit-group-success', () => {
   setMyAccountSettingsAnalytics('list details: edit group settings overlay: group name edited');     
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.rearrange-group', () => {
    setMyAccountSettingsAnalytics('list details: group: group rearranged');     
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.settings-overlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_SETTINGS
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.email-overlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_EMAIL
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.make-note-overlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_MAKE_NOTE
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.note-saved', () => {
    setMyAccountSettingsAnalytics(LIST_NOTE_SAVED);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.select-all', () => {
    setMyAccountSettingsAnalytics(LIST_FUNCTION_SELECT_ALL);      
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.deselect-all', () => {
    setMyAccountSettingsAnalytics(LIST_FUNCTION_DESELECT_ALL);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.compare', () => {
    setMyAccountSettingsAnalytics(LIST_FUNCTION_COMPARE);  
  });

  LIFE_CYCLE_EVENT_BUS.on('intent.edit-name', () => {
    setMyAccountSettingsAnalytics('list details: intent: edit name');     
  });

  LIFE_CYCLE_EVENT_BUS.on('intent.search', () => {
    setMyAccountSettingsAnalytics('list details: intent: search');  
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.pod-action', ({ output }) => {

     const action = output?.action ?? '',
           isIntent = output?.isIntent ?? '' ;

      switch ( action ) {
        case 'replace item':
            setMyAccountSettingsAnalytics( `list details: product pod: ${isIntent ? "intent: " : "resolved: "}${action}` );
            break;
        case 'duplicate item':
        case 'remove item':
            setMyAccountSettingsAnalytics( `list details: product pod: meatball: ${isIntent ? "intent: " : "resolved: "}${action}` );
            break;                   
        case 'add note':
            setMyAccountSettingsAnalytics( `list details: product pod: meatball: ${action}` );
            break;                        
      }   
       
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.tooltip-action', ({ output }) => {

     const action = output?.action ?? '',
           source = output?.source ?? '', 
           hasAIQuantityEstimate = output?.hasAIQuantityEstimate ?? false,
           formattedSourceDetails = ( source === 'lists' ? 'list details' : source === 'projects' ? 'project details' : source );

    setMyAccountSettingsAnalytics( `${source}: ${formattedSourceDetails}: ${hasAIQuantityEstimate ? "active" : "null"} ai quantity calculation tooltip: ${action}` );          
                
  });
};